import { Component, OnInit } from '@angular/core';
import { AdsService } from 'src/app/private/admin/services/ads.service';
 
@Component({
  selector: 'app-get-in-touch',
  templateUrl: './get-in-touch.component.html',
  styleUrls: ['./get-in-touch.component.scss']
})
export class GetInTouchComponent implements OnInit {
  latitude: number=33.889018;
  longitude: number=35.552766;
  zoom: 8;
  adsListUser:[] = []
  adsListAdmin: any = []

  // emailstring= "mailto:info@lebtivity.com"
  constructor(private adsService: AdsService) { }

  ngOnInit(): void {
    this.adsService.getAllAdsUser().then((res:any) => {
      // console.log(res.ads.data)
      this.adsListUser=res.ads.data
      console.log(this.adsListUser)
    })
    this.adsService.getAllAds("123").then((res:any) => {
      // console.log(res.ads.data)
      for(let i=0;i<res.ads.data.length; i++){
        if(res.ads.data[i].status == 1){
          this.adsListAdmin.push({"ads":res.ads.data[i]})
        }
      }
      // this.adsListAdmin=res.ads.data
      console.log(this.adsListAdmin)
    })
  }

}
